import { useQuery, UseQueryOptions } from 'react-query';
import roleUsers, { GetUsersPayload } from 'modules/roles-manager/domain/resources/role-users';
import { User } from 'modules/roles-manager/domain/interfaces/user';

export type UseRoleUsersParams = {
  tournamentId?: number;
  page: number;
  perPage: number;
  filters?: Omit<GetUsersPayload, 'limit' | 'offset'>;
};

export function useRoleUsers(
  { tournamentId, page, perPage, filters }: UseRoleUsersParams,
  options?: UseQueryOptions<User[], unknown, User[]>,
) {
  const offset = Math.max(0, (page - 1) * (perPage || 1));
  const limit = perPage;

  return useQuery<User[]>(
    ['roleUsers', tournamentId, filters, { limit, offset }],
    () => {
      if (!tournamentId) return Promise.resolve([]);
      const params: GetUsersPayload = { limit, offset, ...(filters || {}) };
      return roleUsers.getUsers(tournamentId, params);
    },
    {
      keepPreviousData: true,
      staleTime: 60_000,
      enabled: Boolean(tournamentId),
      ...options,
    },
  );
}

export default useRoleUsers;
